/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Common,
  CreateNoticeDtoTx,
  DeleteNoticeDtoTx,
  GetDetailNoticeDtoRx,
  GetNoticeDtoRx,
  NoticeControllerGetNoticesParams,
  UpdateNoticeDtoTx,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class NotcieApi<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Notcie API
   * @name NoticeControllerGetNotices
   * @summary 공지사항 조회
   * @request GET:/api/notice
   * @secure
   */
  noticeControllerGetNotices = (query: NoticeControllerGetNoticesParams, params: RequestParams = {}) =>
    this.request<GetNoticeDtoRx, any>({
      path: `/api/notice`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Notcie API
   * @name NoticeControllerCreateNotice
   * @summary 공지사항 등록
   * @request POST:/api/notice
   * @secure
   */
  noticeControllerCreateNotice = (data: CreateNoticeDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/notice`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Notcie API
   * @name NoticeControllerDeleteNotice
   * @summary 공지사항 삭제
   * @request DELETE:/api/notice
   * @secure
   */
  noticeControllerDeleteNotice = (data: DeleteNoticeDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/notice`,
      method: 'DELETE',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Notcie API
   * @name NoticeControllerGetNotice
   * @summary 공지사항 상세 조회
   * @request GET:/api/notice/{id}
   * @secure
   */
  noticeControllerGetNotice = (id: number, params: RequestParams = {}) =>
    this.request<GetDetailNoticeDtoRx, any>({
      path: `/api/notice/${id}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Notcie API
   * @name NoticeControllerUpdateNotice
   * @summary 공지사항 수정
   * @request PUT:/api/notice/{id}
   * @secure
   */
  noticeControllerUpdateNotice = (id: number, data: UpdateNoticeDtoTx, params: RequestParams = {}) =>
    this.request<Common, any>({
      path: `/api/notice/${id}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
